module.exports = __webpack_public_path__ + "img/3.12a83971.jpg";